module.exports = __webpack_public_path__ + "static/media/settings.e171945a.svg";